import 'reflect-metadata';
import Vue, { CreateElement } from 'vue';
// plugins
import container from '@/plugins/services';
import '@/plugins/env';
// entry component
import EventiGrid from './EventiGrid.vue';

new Vue({
    provide: {
        ...container.getAll()
    },
    render(h: CreateElement) {
        return h(EventiGrid);
    }
}).$mount('#eventigrid');
